import { ReportFileViewerPage } from '@/features/reports/report-file-viewer-page';

const Dac8AuditViewerPage = () => <ReportFileViewerPage backLabel="Back to DAC8" backTo="/compliance/dac8" />;
Dac8AuditViewerPage.displayName = 'Dac8AuditViewerPage';

export default Dac8AuditViewerPage;
